import React, { useEffect, useState } from 'react';
import Head from '../../../../layout/head/Head';
import Content from '../../../../layout/content/Content';
import FeatureUnderDevelopment from '../../../loaders/FeatureUnderDevelopment';
import { Block, BlockBetween, BlockDes, BlockHead, BlockHeadContent, BlockTitle, Button, DataTableHead, DataTableItem, DataTableRow, Icon, PaginationComponent } from '../../../../components/Component';
import { Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import AuthTenantPageError from '../../../error/AuthTenantPageError';
import AuthTenantLoader from '../../../loaders/AuthTenantLoader';
import AuthTenantNoData from '../../../error/AuthTenantNoData';
import { TENANT_RETRIEVE_PARTICIPANTS_API } from '../../../../api/api_data';
import { tenant_auth_actions_helper } from '../../../../actions/actions_helper';
import { fail_retrieve_tenant_participants, loading_retrieve_tenant_participants, reset_retrieve_tenant_participants, success_retrieve_tenant_participants } from '../../../../reducers/auth_tenant/retrieve_tenant_participants_Slice';
import { RETRIEVE_PARTICIPANTS_ERROR_MSG, RETRIEVE_PARTICIPANTS_SUCCESS_MSG } from '../../../../utils/error_success_messages';
import { useSelector } from 'react-redux';
import { messageToast } from '../../../../utils/Utils';
import * as app_consts from "../../../../utils/app_consts";
import moment from 'moment';
import { Badge } from 'reactstrap';

const ParticipantsList = ({ tenant_info, user_info }) => {

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [page_data, setPageData] = useState([]);
  const [current_page_data, setCurrentPageData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemPerPage] = useState(20);
  const [sm, updateSm] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");

  const dispatch = useDispatch();

  useEffect(() => {
    retrieve_data();
  }, []);

  const retrieve_data = () => {
    setError("");
    setLoading(true);
    // Retreive Employees
    dispatch(tenant_auth_actions_helper(loading_retrieve_tenant_participants, success_retrieve_tenant_participants, fail_retrieve_tenant_participants, RETRIEVE_PARTICIPANTS_ERROR_MSG, RETRIEVE_PARTICIPANTS_SUCCESS_MSG, app_consts.GET, `/${tenant_info?.url_prefix}/${TENANT_RETRIEVE_PARTICIPANTS_API}`));
  };

  // Listener
  const retrieve_tenant_participants_listener = useSelector((state) => state.retrieve_tenant_participants.retrieve_tenant_participants);

  useEffect(() => {
    if (retrieve_tenant_participants_listener.status !== app_consts.IDLE)
    {
      if (retrieve_tenant_participants_listener.status === app_consts.LOADING)
      {
        setLoading(true);
        setError("");
      } else
      {
        if (retrieve_tenant_participants_listener.status === app_consts.FAIL)
        {
          setError(retrieve_tenant_participants_listener.message, app_consts.FAIL);
          setLoading(false);
          messageToast(retrieve_tenant_participants_listener.message, app_consts.FAIL);
        } else if (retrieve_tenant_participants_listener.status === app_consts.SUCCESS)
        {
          setPageData(retrieve_tenant_participants_listener.data);
          setCurrentPageData(retrieve_tenant_participants_listener.data);
          const timer = setTimeout(() => {
            setLoading(false);
          }, 1000);

          return () => clearTimeout(timer); // cleanup in case the component unmounts
        }
        dispatch(reset_retrieve_tenant_participants());
      }
    }
  }, [retrieve_tenant_participants_listener]);

  // Get current list, pagination
  const indexOfLastItem = currentPage * itemPerPage;
  const indexOfFirstItem = indexOfLastItem - itemPerPage;
  const currentItems = current_page_data?.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  // Calculate the start and end index for the current page
  const startIndex = (currentPage - 1) * itemPerPage;
  const endIndex = startIndex + itemPerPage;

  useEffect(() => {
    filtered_data(searchTerm);
  }, [searchTerm]);

  const filtered_data = (searchItem) => {
    if (searchItem)
    {
      let displayedParticipants;

      displayedParticipants = page_data?.filter((item) => {
        const combinedParams = [
          item?.first_name,
          item?.first_name ? `${item?.first_name} ${item?.last_name}` : "--",
          item?.first_name ? `${item?.first_name} ${item?.middle_name || ""} ${item?.last_name || ""}` : "--",
          item?.last_name,
          item?.mobile_number,
          item?.email_address,
          item.total_entries,
          item.total_promotions,
          item.gender,
          item?.inserted_at ? moment(item?.inserted_at).format("YYYY-MM-DD HH:mm:ss") : "--",
          item?.dob ? moment(item?.dob).format("YYYY-MM-DD") : "--"
        ]
          .join(" ")
          .toLowerCase();

        return combinedParams.includes(searchItem.toLowerCase());
      }).slice(startIndex, endIndex);

      setCurrentPageData(displayedParticipants);
    } else
    {
      setCurrentPageData(page_data);
    }
  };

  return (
    <>
      <Head
        title={
          tenant_info?.name ? `${tenant_info.name} Participants List` : ' Participants List'
        }
      />
      <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page>Participants</BlockTitle>
              <BlockDes className="text-soft">
                <p>{!(loading || error) && `Participants ${current_page_data?.length}`}</p>
              </BlockDes>
              {!(loading) && (
                <div className="mt-2">
                  <Link
                    onClick={(e) => {
                      e.preventDefault();
                      retrieve_data();
                    }}
                  >
                    <Button color="light" outline className="bg-white d-none d-sm-inline-flex">
                      <span>Refresh List</span>
                    </Button>
                  </Link>
                </div>
              )}
            </BlockHeadContent>
            <BlockHeadContent>
              <div className="toggle-wrap nk-block-tools-toggle">
                <a
                  href="#more"
                  className="btn btn-icon btn-trigger toggle-expand me-n1"
                  onClick={(ev) => {
                    ev.preventDefault();
                    updateSm(!sm);
                  }}
                >
                  <Icon name="more-v"></Icon>
                </a>
                <div className="toggle-expand-content" style={{ display: sm ? "block" : "none" }}>
                  <ul className="nk-block-tools g-3">
                    <li>
                      <div className="form-control-wrap">
                        <div className="form-icon form-icon-right">
                          <Icon name="search"></Icon>
                        </div>
                        <input
                          type="text"
                          className="form-control"
                          id="default-04"
                          value={searchTerm}
                          onChange={e => setSearchTerm(e.target.value)}
                          placeholder="Search for Participant"
                        />
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>
        {
          loading ?
            <>
              <AuthTenantLoader tenant_info={tenant_info} loading_message="Loading Participants..." />
            </>
            :
            <>
              {
                error ?
                  <>
                    <AuthTenantPageError tenant_info={tenant_info} error_message={error} />
                  </>
                  :
                  <>
                    {
                      page_data && page_data?.length > 0 ?
                        <>
                          <Block>
                            <div className="nk-tb-list is-separate is-medium mb-3">
                              <DataTableHead className="nk-tb-item">
                                <DataTableRow>
                                  <span className="sub-text">Name</span>
                                </DataTableRow>
                                <DataTableRow size="mb">
                                  <span className="sub-text">Mobile Number</span>
                                </DataTableRow>
                                <DataTableRow size="lg">
                                  <span className="sub-text">DOB</span>
                                </DataTableRow>
                                <DataTableRow size="lg">
                                  <span className="sub-text">Gender</span>
                                </DataTableRow>
                                <DataTableRow size="md">
                                  <span className="sub-text">Created On</span>
                                </DataTableRow>
                                <DataTableRow size="md">
                                  <span className="sub-text">Promotions</span>
                                </DataTableRow>
                                <DataTableRow size="md">
                                  <span className="sub-text">Action</span>
                                </DataTableRow>
                              </DataTableHead>
                              {currentItems.length > 0
                                ? currentItems.map((item) => (
                                  <DataTableItem key={item.id}>
                                    <DataTableRow>
                                      <Link /* to={`/${tenant_info.url_prefix}/employees/${item?.account?.mobile_number}`} */>
                                        <div className="user-card">
                                          <div className="user-info">
                                            <span className="tb-lead">
                                              {item?.first_name ? `${item?.first_name} ${item?.middle_name || ""} ${item?.last_name || ""}` : "--"}<span className="dot dot-success d-md-none ms-1"></span>
                                            </span>
                                          </div>
                                        </div>
                                      </Link>
                                    </DataTableRow>
                                    <DataTableRow>
                                      <div className="user-card">
                                        <div className="user-info">
                                          <span className="tb-lead">
                                            {item?.mobile_number || "--"}<span className="dot dot-success d-md-none ms-1"></span>
                                          </span>
                                          MNO | <span>{item?.mobile_network_provider?.replace(/_/g, ' ').toUpperCase() || "--"}</span>
                                        </div>
                                      </div>
                                    </DataTableRow>
                                    <DataTableRow>
                                      <span className="tb-odr-date">{item?.dob ? moment(item?.dob).format("YYYY-MM-DD") : "--"}</span>
                                    </DataTableRow>
                                    <DataTableRow>
                                      <span>{item?.gender || "--"}</span>
                                    </DataTableRow>
                                    <DataTableRow size="mb">
                                      <span className="tb-odr-date">{item?.inserted_at ? moment(item?.inserted_at).format("YYYY-MM-DD HH:mm:ss") : "--"}</span>
                                    </DataTableRow>
                                    <DataTableRow>
                                      <div className="user-card">
                                        <div className="user-info">
                                          <span className="tb-lead">
                                            {item?.total_promotions || "0"}<span className="dot dot-success d-md-none ms-1"></span>
                                          </span>
                                          Entries | <span>{item?.total_entries || "0"}</span>
                                        </div>
                                      </div>
                                    </DataTableRow>
                                    <DataTableRow>
                                    </DataTableRow>
                                  </DataTableItem>
                                ))
                                : null}
                            </div>
                            {currentItems?.length > 0 && (
                              <div className="mt-3">
                                <PaginationComponent
                                  itemPerPage={itemPerPage}
                                  totalItems={current_page_data?.length}
                                  paginate={paginate}
                                  currentPage={currentPage}
                                />
                              </div>
                            )}
                          </Block>
                        </>
                        :
                        <>
                          <AuthTenantNoData tenant_info={tenant_info} no_data_message={"No Participants Found."} />
                        </>
                    }
                  </>
              }
            </>
        }
      </Content>
    </>
  );
};

export default ParticipantsList;